import { createStore } from 'vuex'
import getters from './getters';
import app from './modules/app';
import user from './modules/user';

// 创建一个新的 store 实例
const store = createStore({
  modules:{
    app,
    user
  },
  getters,
})



export default store;